import '../App.css';
import React, { useEffect } from 'react'
import { Route, Routes } from "react-router-dom";
import SPPIF from '../Projects/SPPIF'
import IntegratedProject from '../Projects/IntegratedProject';
import WebCarMuseum from '../Projects/WebCarMuseum'
import ArduinoProject from '../Projects/ArduinoProject';
import FinalProject from '../Projects/FinalProject';
import NavBar from '../Widgets/NavBar';
import Footer from '../Widgets/Footer';

export default function ProjectsLandingPage() {
    return (
        <div>
            <Routes>
                <Route path='/' element={<LandingPage></LandingPage>}>
                </Route>
                <Route path='SPPIF' element={<SPPIF></SPPIF>}>
                </Route>
                <Route path='final-project' element={<FinalProject></FinalProject>}>
                </Route>
                <Route path='integrated-project' element={<IntegratedProject></IntegratedProject>}>
                </Route>
                <Route path='car-museum' element={<WebCarMuseum></WebCarMuseum>}>
                </Route>
                <Route path='arduino' element={<ArduinoProject></ArduinoProject>}>
                </Route>
            </Routes>
        </div>
    )

    function LandingPage() {
        return (
            <div className="page-wrapper">
                <header className="py-5">
                    <div className="container">
                        <div className="row">
                            <NavBar selected='projects-page'></NavBar>
                        </div>
                    </div>
                </header>

                <section id="about" className="py-5 content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="section-title">List of projects</h2>
                                <ul style={{ margin: "10px" }}>
                                    <Projetos></Projetos>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer></Footer>
            </div>
        )
    }

    function Projetos() {
        let projetos = [
            ['SPPIF (Sistema de Prevenção e Proteção contra Incêndios Florestais)', '/projects/SPPIF'],
            ['Human Resources Management Website', '/projects/final-project'],
            ['Blog/Reddit Website and Mobile App (Integrated Project)', '/projects/integrated-project'],
            ['Arduino Temperature, Humidity and Light Project', '/projects/arduino'],
            ['Web Car Museum', '/projects/car-museum'],
        ]
        return projetos.map((project) => {
            return (
                <li style={{ margin: "10px", marginBottom: "20px" }}>
                    <div>
                        <a href={project[1]} className='special-link' style={{ color: 'white' }}>
                            <h4 className="clickable">{project[0]}</h4>
                        </a>
                    </div>
                </li>
            )
        })
    }
}


